import {Service} from './request'

export default {
    getMenusPage(param) {
        return Service.post("/menu/query/page", param);
    },
    addMenu(menu) {
        return Service.post('/menu/add/single', menu)
    },
    deleteMenu(id) {
        let param = {
            id: id
        };
        return Service.post('/menu/delete/single', param);
    },
    updateMenu(menu) {
        return Service.post('/menu/update/single', menu);
    },
    updateStatus(menu) {
        return Service.post('/menu/updateStatus', menu);
    },
    getMenuAll(name) {
        let param = {
            "name": name
        }
        return Service.post('/menu/query/all', param);
    },
    queryMenu(id) {
        let param = {
            id
        };
        return Service.post('/menu/query/single', param);
    },
    deleteMenuList(ids) {
        let param = {
            id: ids.join(',')
        };
        return Service.post('/menu/delete/list', param);
    },
    // V4.1.2 全量菜单树（含 disabled），用于菜单管理页树形展示
    getMenuTree() {
        return Service.post('/menu/query/tree', {});
    },
    // V4.1.2 给指定 parent 加子菜单
    addChildMenu(parentId, menu) {
        return Service.post('/menu/add/child', {
            parentId,
            ...menu
        });
    },
    // V4.1.2 上/下移：同 parent 下相邻菜单交换 sort
    // statusFilter: 可选，传 'enable'/'disable' 时会跳过状态不匹配的兄弟，避免"隐藏菜单挡道"
    swapMenuOrder(menuId, direction, statusFilter) {
        return Service.post('/menu/swap-order', { menuId, direction, statusFilter });
    },

    // V4.1.2 数字货币列表（用于平台账户币种下拉）
    digitCurrencyByAll()            { return Service.post('/digit/currency/by/all', {}); },

    // V4.1.2 平台账户管理
    platformAccountList()           { return Service.post('/platform-account/list', {}); },
    platformAccountDetail(id)       { return Service.post('/platform-account/detail', { id }); },
    platformAccountSave(account)    { return Service.post('/platform-account/save', account); },
    platformAccountUpdate(account)  { return Service.post('/platform-account/update', account); },
    platformAccountAdjust(payload)  { return Service.post('/platform-account/adjust', payload); },
    platformAccountFlows(payload)   { return Service.post('/platform-account/flows', payload); },

    // 角色
    getRolePage(param) {
        return Service.post("/role/query/page", param);
    },
    deleteRole(id) {
        let param = {
            id: id
        };
        return Service.post('/role/delete/single', param);
    },
    addRole(role) {
        return Service.post('/role/add/single', role)
    },
    updateRole(role) {
        return Service.post('/role/update/single', role)
    },
    queryRole(id) {
        let param = {
            id
        };
        return Service.post('/role/query/single', param);
    },
    deleteRoleList(ids) {
        let param = {
            id: ids.join(',')
        };
        return Service.post('/role/delete/list', param);
    },
    /**
     * 切换角色「禁止删除」标志，仅 sysadmin 可调用
     * @param {Number} id              角色 ID
     * @param {Number} deleteProtected 0 关闭保护，1 开启保护
     */
    toggleRoleDeleteProtected(id, deleteProtected) {
        return Service.post('/role/admin/toggle-delete-protected', { id, deleteProtected });
    },
    /**
     * 根据userId 获取用户可显示的菜单
     * @param userId
     * @returns {Promise<AxiosResponse<any>>}
     */
    getMenuShow(userId) {
        let param = {
            userId: userId
        };
        return Service.post('/menu/get/show', param);
    },

    /**
     * 根据userId 获取用户设置时可显示的菜单
     * @param userId
     * @returns {Promise<AxiosResponse<any>>}
     */
    getMenuShowInDesign(userId) {
        let param = {
            userId: userId
        };
        return Service.post('/menu/get/design/show', param);
    }
}